module.exports = __webpack_public_path__ + "static/media/48100003-b2S0wSgs.1b405bb1.JPG";